import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { take } from 'rxjs/operators';
import { DropBoxService } from '../../form-fields/drop-box-upload/drop-box.service';

@Component({
  selector: 'sc-field-image-upload',
  templateUrl: './field-image-upload.component.html',
  styleUrls: ['./field-image-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FieldImageUploadComponent),
      multi: true
    }
  ]
})
export class FieldImageUploadComponent extends FieldType implements OnInit {
  loading: boolean;

  constructor(private _googleDriveService: DropBoxService) {
    super();
  }

  ngOnInit(): void {}

  uploadFile(filelist: File[]) {
    console.log(filelist);
    this.loading = true;
    this._googleDriveService
      .upload([...filelist])
      .pipe(take(1))
      .subscribe(
        ([file]) => {
          this.loading = false;
          this.formControl.setValue(file.id);
          this.options.resetModel({
            ...this.model,
            docType: filelist[0].type
          });
        },
        () => {
          this.loading = false;
        }
      );
  }
}
